import { CustomArray } from "./BaseModel";

export class Feedback {
  constructor(
    public readonly id: string,
    public readonly messageId: string | undefined,
    public readonly score: number,
    public readonly comment: string,
  ) {
  }
}

export class Feedbacks extends CustomArray<Feedback> {
  threadFeedback = (): Feedback | undefined => {
    return this.findLast((feedback) => !feedback.messageId);
  };

  getForMessage(messageId: string): Feedback | undefined {
    return this.findLast((feedback) => feedback.messageId === messageId);
  }

  update(newFeedback: Feedback): Feedbacks {
    const existingIndex = this.findIndex((feedback) => feedback.messageId === newFeedback.messageId);

    const updatedItems = [...this];

    if (existingIndex >= 0) {
      updatedItems[existingIndex] = newFeedback;
    } else {
      updatedItems.push(newFeedback);
    }

    return new Feedbacks(updatedItems);
  }
}
